import stylex from '@stylexjs/stylex';
export const styles = stylex.create({
  container: {
    display: 'flex',
    padding: '0 20px',
    alignItems: 'flex-start',
    gap: '12px',
    alignSelf: 'stretch',
    boxSizing: 'border-box',
    width: '100%',
    overflow: 'visible',
  },
  main: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    flex: '1 0 0',
    borderLeft: '2px solid #D0D5DD',
    paddingLeft: '12px',
    width: '100%',
  },
  overlay: {
    display: 'flex',
    justifyContent: 'center',
  },
});
